export default __webpack_public_path__ + "static/media/visa-e.714fc404.svg";